import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function PreferencesIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 20 19"
        {...props}
      >
        <path d="M.77 3.85h2.15a3.07 3.07 0 0 0 3.73 2.22 3.08 3.08 0 0 0 2.22-2.22h10.36c.43 0 .77-.34.77-.77s-.34-.77-.77-.77H8.87A3.07 3.07 0 0 0 5.14.09a3.08 3.08 0 0 0-2.22 2.22H.82c-.43 0-.77.34-.77.77s.34.77.77.77zM5.9 1.54a1.54 1.54 0 1 1-1.54 1.54c0-.85.69-1.54 1.54-1.54M19.23 8.73H18.1a3.06 3.06 0 0 0-3.71-2.23c-1.1.27-1.96 1.13-2.23 2.23H.77c-.43 0-.77.34-.77.77s.34.77.77.77h11.39a3.06 3.06 0 0 0 3.71 2.23c1.1-.27 1.96-1.13 2.23-2.23h1.13c.43 0 .77-.34.77-.77s-.34-.77-.77-.77M15.13 11a1.54 1.54 0 1 1 1.54-1.54v.04c-.02.83-.7 1.5-1.54 1.5M19.23 15.15h-8.31a3.071 3.071 0 0 0-5.94 0H.77c-.43 0-.77.34-.77.77s.34.77.77.77H5a3.06 3.06 0 0 0 3.71 2.23c1.1-.27 1.96-1.13 2.23-2.23h8.31c.43 0 .77-.34.77-.77s-.34-.77-.77-.77zM8 17.46a1.54 1.54 0 1 1 1.54-1.54c0 .85-.69 1.54-1.54 1.54" />
      </svg>
    </Icon>
  )
}
export default PreferencesIcon
